/**
 * field.state.meta.errors에서 에러 메시지를 추출하는 유틸리티
 *
 * TanStack Form validator가 plain string 또는 { message: string } 객체를
 * 반환할 수 있으므로, 두 형식 모두 처리
 */
export function getFieldError(error: unknown): string | undefined {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error)
    return (error as { message: string }).message;
  return undefined;
}
